<div class="bg">
    <fury-page>
      <fury-title class="title">
        <span [@fadeInRight]>Update Lead Message</span>
      </fury-title>
    </fury-page>
    <div fxLayout="column" fxLayoutAlign="start center">
      <div [@fadeInUp] class="card">
          <form [formGroup]="leadMessageForm">
            <div class="content" fxLayout="column" fxLayoutGap="8px">
                <mat-form-field style="width: 100%; margin-bottom: 16px;" appearance="outline">
                    <mat-label>State Type</mat-label>
                    <mat-select formControlName="stateType" [disabled]="true">
                      <mat-option value="covered">Covered</mat-option>
                      <mat-option value="not-covered">Not Covered</mat-option>
                    </mat-select>
                    <mat-error
                      *ngIf="leadMessageForm.controls['stateType'].touched && leadMessageForm.controls['stateType'].hasError('required')">
                      This is a required field.
                    </mat-error>
                  </mat-form-field>
            <div *ngIf="pageName == 'not-covered'"> 
              <fxLayout fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px"
              style="margin-bottom: 20px;align-items: baseline; width: 100% !important;">
              <div class="flex">
                <div class="innerdiv">
                  <div class="uploadsec" style="margin-right: 20px">
                    <div class="imgsec">
                      <img [src]="bannerImage ?  bannerImage : '../../../../../assets/img/no_thumbnail.jpg'" alt="badge_image"> 
                      <span (click)="removeBadge()" *ngIf="bannerImage" class="removebadge"><mat-icon>close</mat-icon></span>
                    </div>
                    <div class="uploadbtnsec">
                      <input type="file" #image_one (change)="onImageUpload($event)" accept=".png, .jpg, .jpeg"
                        style="display:none">
                      <button class="uploadfilebtn" mat-raised-button (click)="image_one.click()">Upload image</button>
                    </div>
                  </div>
                </div>
              </div>
              </fxLayout>
    
              <fxLayout fxLayout="column" fxLayout.gt-md="column" fxLayoutGap.gt-md="24px" style="margin-bottom: 20px; width: 100% !important;">
                <mat-label><b>Uncovered State Top Message</b></mat-label>
                <ckeditor [config]="editorConfig" formControlName="uncoveredStateTopMessage" debounce="500"></ckeditor>
                <mat-error
                *ngIf="leadMessageForm.controls['uncoveredStateTopMessage'].touched && leadMessageForm.controls['uncoveredStateTopMessage'].hasError('required')" style="font-size:13px;">
                This is a required field.</mat-error>
              </fxLayout>
              
              <mat-form-field style="width: 100%;" appearance="outline">
                <mat-label>Uncovered State Bottom Message</mat-label>
                <textarea type="text" matInput placeholder="Uncovered State Bottom Message" formControlName="uncoveredStateBottomMessage"> </textarea>
                <mat-error *ngIf="leadMessageForm.controls['uncoveredStateBottomMessage'].touched && leadMessageForm.controls['uncoveredStateBottomMessage'].hasError('required')">
                    This is a required field.</mat-error>
              </mat-form-field>
              <mat-form-field style="width: 100%;" appearance="outline">
                <mat-label>Cpl</mat-label>
                <input matInput placeholder="Cpl"  formControlName="cpl" mask="separator.2" thousandSeparator="," separatorLimit="99999999999999">
                <mat-error *ngIf="leadMessageForm.controls['cpl'].touched && leadMessageForm.controls['cpl'].hasError('required')">
                  This is a required field.</mat-error>
              </mat-form-field>
              <div>
                <!-- Redirection section -->
                <section class="example-section" style="margin-bottom: 10px;">
                  <mat-checkbox class="example-margin" formControlName="isRedirect">Allow Redirection</mat-checkbox>
                </section>
                <mat-form-field style="width: 100%;" appearance="outline">
                  <mat-label>Redirect Url</mat-label>
                  <input matInput placeholder="Url"  formControlName="url" [attr.disabled]="!leadMessageForm.controls['isRedirect'].value ? true : null">
                  <mat-error *ngIf="leadMessageForm.controls['url'].touched && leadMessageForm.controls['url'].hasError('required')">
                    This is a required field.</mat-error>
                    <mat-error *ngIf="leadMessageForm.controls['url'].touched && leadMessageForm.controls['url'].hasError('pattern')">
                      This is a required field.</mat-error>
                </mat-form-field>
                <mat-form-field style="width: 100%;" appearance="outline">
                  <mat-label>Redirect After (sec)</mat-label>
                  <input type="number" matInput placeholder="Redirect Time (sec)"  formControlName="secondTimer" (keypress)="apiService.allowNumbers($event)" [attr.disabled]="!leadMessageForm.controls['isRedirect'].value ? true : null">
                  <mat-error *ngIf="leadMessageForm.controls['secondTimer'].touched && leadMessageForm.controls['secondTimer'].hasError('required')">
                    This is a required field.</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div *ngIf="pageName == 'covered'">
                <fxLayout fxLayout="column" fxLayout.gt-md="column" fxLayoutGap.gt-md="24px" style="margin-bottom: 20px; width: 100% !important;">
                    <mat-label><b>Covered State Message</b></mat-label>
                    <ckeditor [config]="editorConfig" formControlName="coveredStateMessage" debounce="500"></ckeditor>
                    <mat-error
                    *ngIf="leadMessageForm.controls['coveredStateMessage'].touched && leadMessageForm.controls['coveredStateMessage'].hasError('required')" style="font-size:13px;">
                    This is a required field.</mat-error>
                  </fxLayout>
            </div>
            </div>
            <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
            
              <button mat-button type="button" class="sub-button" (click)="update()"><span>Update</span></button>
            </div>
    
             
            </form>
      </div>
    </div>
    </div>
